import compaigncard  from  './images/compaigncard.png'


export const compaignData = [
    {
      id:1, 
      img: compaigncard ,  
      name:"Mark Bla",
      job: "Intern",
      progress:'70%',
      funded:"$700",
      left: "$300",
      loan:'$10000'
    },
    {
        id:2, 
        img: compaigncard ,  
        name:"Mark Bla",
        job: "Intern",
        progress:'70%',
        funded:"$700",
        left: "$300",
        loan:'$10000'
      },
      {
        id:3, 
        img: compaigncard ,  
        name:"Mark Bla",
        job: "Intern",
        progress:'70%',
        funded:"$700",
        left: "$300",
        loan:'$10000'
      },
      {
        id:4, 
        img: compaigncard ,  
        name:"Mark Bla",
        job: "Intern",
        progress:'70%',
        funded:"$700",
        left: "$300",
        loan:'$10000'
      },

  ];